var _defs, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIpad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 69,
    viewBox: "0 0 56 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -19.95,
    y1: -0.449,
    x2: -19.95,
    y2: -0.381,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(-0.002 0.011)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ipad-stop",
    transform: "translate(0.002 -0.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.8,
    cy: 2.8,
    r: 2.8,
    transform: "translate(25.2 63.4)",
    fill: "#07d4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.518,60.133C10.166,59.133,0,54.033,0,47.933c0-6.8,12.555-12.4,28-12.4s28,5.5,28,12.4c0,6.1-10.164,11.2-23.416,12.2-3.886.8-4.584,2.6-4.584,2.6a7.677,7.677,0,0,0-4.484-2.6Z",
    transform: "translate(-0.002 -0.233)",
    fillRule: "evenodd",
    opacity: 0.1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.518,55.612a27.886,27.886,0,1,1,9.068,0A8.484,8.484,0,0,0,28,61.589S26.208,56.509,23.518,55.612Z",
    transform: "translate(-0.002 0.011)",
    fill: "#07d4bf",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(13.201 17.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M37.3,33.2V23a1.58,1.58,0,0,0-1.6-1.6h-19A1.58,1.58,0,0,0,15.1,23V37.2a1.58,1.58,0,0,0,1.6,1.6h19c1.5,0,1.6-1.6,1.6-1.6S37.4,33.4,37.3,33.2Z",
    transform: "translate(-13.3 -17.5)",
    fill: "#fff",
    opacity: 0.38,
    style: {
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M40.8,17.5H14.7a1.772,1.772,0,0,0-1.4,1.9V37.7a1.888,1.888,0,0,0,2,2H40.7a3.553,3.553,0,0,0,1-.2c.6-.2.8-.7,1-1.3V19A1.692,1.692,0,0,0,40.8,17.5ZM14.7,28.9a.3.3,0,1,1,.3-.3A.265.265,0,0,1,14.7,28.9Zm25.5,9.5H16V18.9H39.8c.3,0,.3.1.3.3V38.4Zm1-9.2a.5.5,0,1,1,.5-.5C41.8,28.9,41.5,29.2,41.2,29.2Z",
    transform: "translate(-13.3 -17.5)",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M33.3,34.3a1.193,1.193,0,0,0,1.2-1.1V26.7a1.3,1.3,0,0,0-1.3-1.1,1.273,1.273,0,0,0-1.1,1.1v5.4H31V24.6a1.3,1.3,0,0,0-1.3-1.1,1.273,1.273,0,0,0-1.1,1.1v7.5H27.4V28.8a1.3,1.3,0,0,0-1.3-1.1A1.273,1.273,0,0,0,25,28.8v3.3H24V26.7a1.3,1.3,0,0,0-1.3-1.1,1.273,1.273,0,0,0-1.1,1.1v6.5a1.135,1.135,0,0,0,1.2,1.1Z",
    transform: "translate(-13.3 -17.5)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpad);
export default __webpack_public_path__ + "static/media/ipad.9072efdcded29388a7a46ba01f35b2c2.svg";
export { ForwardRef as ReactComponent };